import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportCloudRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-cloud',
	path: '/secure/admin/CloudImport([!%]?[\\w]*).jspa',
};
